import React from "react";
import { withRefluxStore } from "../../../../Stores";
import AdAssistantStore from "../../AdAssistantStore";

import { FlipBackward } from "@untitledui/icons/FlipBackward";
import { FlipForward } from "@untitledui/icons/FlipForward";
import { ArrowButton, ArrowGroup } from "./VersionNavigation.styled";
import { ActionsAdAssistant } from "../../../../Actions/ActionsAdAssistant/ActionsAdAssistant";

const VersionNavigation = ({
  // Store
  adVersions,
  currentAdVersion,
  currentAd,
  isLoadingVersions,
  isLoadingMoreVersions,
  isLoadingActiveAdVersion,
  hasMoreVersions
}) => {
  const selectedIdx = adVersions.findIndex((v) => v.version === currentAd.version);
  const disableBackButton = selectedIdx === -1 || selectedIdx === 0 || adVersions.length === 0;
  const disableForwardButton = selectedIdx === adVersions.length - 1;

  const selectPrev = () => {
    const adVersion = adVersions[selectedIdx - 1];
    if (adVersion) {
      ActionsAdAssistant.setCurrentAdVersion(adVersion);
    }
  };

  const selectNext = () => {
    const adVersion = adVersions[selectedIdx + 1];
    if (adVersion) {
      ActionsAdAssistant.setCurrentAdVersion(adVersion);
    }
  };

  return (
    <ArrowGroup>
      <ArrowButton onClick={selectPrev} disabled={disableBackButton}>
        <FlipBackward size={20} color="var(--primary-blue)" />
      </ArrowButton>
      <ArrowButton onClick={selectNext} disabled={disableForwardButton}>
        <FlipForward size={20} color="var(--primary-blue)" />
      </ArrowButton>
    </ArrowGroup>
  );
};

export default withRefluxStore(
  VersionNavigation,
  [AdAssistantStore],
  [
    "adVersions",
    "currentAdVersion",
    "currentAd",
    "isLoadingVersions",
    "isLoadingMoreVersions",
    "isLoadingActiveAdVersion",
    "hasMoreVersions"
  ]
);
